'use strict';

const videoControls = require("../video-controls");
const animations = require("../animation.product-finder");

const startExperience = (buttonClicked) => {
    // Add active class during animation and remove it after
    $(buttonClicked).addClass('active');
    setTimeout(() => {
        $(buttonClicked).removeClass('active');
    }, window.STEP_ANIMAION_DURATION);

    const oppositeDirection = false;

    $.ajax({
        url: $(buttonClicked).attr('action'),
        type: 'GET',
        complete: async function (data) {
            let content = $('.step-container', data.responseText);
            window.isLoading = false;

            if (content) {
                $('.steps').append(content.html());
            }

            if (videoControls.isVideoPaused) {
                videoControls.pauseVideos();
            }

            // Animate steps
            await animations.animateSteps(oppositeDirection);

            setTimeout(() => {
                window.isLoading = false;
            }, window.STEP_ANIMAION_DURATION);
        },
    });
};

$(document.body).on('click', '.start-experience-button', function (e) {
    if (window.isLoading) {
        return;
    }

    window.isLoading = true;
    e.preventDefault();

    startExperience(e.currentTarget);
});
